/* eslint-disable no-unused-vars */
import React, { useState } from "react";
import {
  Grid,
  Paper,
  Alert,
  Button,
  Box,
  Tabs,
  Tab,
  Divider,
  TableContainer,
  TableRow,
  Table,
  TableHead,
  TableCell,
  TableBody,
} from "@mui/material";

import { useSelector } from "react-redux";
import { useFormik, FormikProvider, Form } from "formik";
// import { useNavigate } from "react-router-dom";
import Loader from "../../loader/loader";
import AlertMsg from "../../common/alert";
import useApiState from "../common/useApiState";
import { labels } from "../../../lang/labels";
import {
  FormLabel,
  FormValue,
  GridRow,
} from "../counter/generate-receipt/custom-form-grid";
// import FormTitle from "../../form-fields/form-title";
import TextInput from "../../form-fields/text-input";
import DashBoardContainer from "../../layout/dashboard-container";
import SelectInput from "../../form-fields/select-input";
import { Search, SettingsInputAntenna } from "@mui/icons-material";
import { getErrorMsg } from "../../../utils/helpers";
import {
  getPropertyByMarathiName,
  getPropertyByMobileOrPropertyNo,
  getPropertyByUPICID,
} from "../../../services/property-details";
import {
  getGatByZonekey,
  getUserZoneList,
} from "../../../services/master-service";
import ScrollTop from "../../common/scrollTop";
import { showToastError, showToastSuccess } from "../../common/toastHelper";

const TabPanel = (props) => {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
    </div>
  );
};

const SearchProperty = () => {
  // const navigate = useNavigate();
  const initialState = {
    searchPropertyBy: "",
    propertyAddress: "",
    upicid: "",
  };
  const { loading, setLoading, error, setError, success, setSuccess } =
    useApiState();
  const [tabValue, setTabValue] = useState(0);
  const [propertyData, setPropertyData] = useState("");
  const [zonesList, setZonesList] = useState([]);
  const [gatList, setGatList] = useState([]);

  const lang = useSelector((state) => state.userDetails.lang);
  const formik = useFormik({
    initialValues: initialState,
  });

  const handleChange = async (event, newValue) => {
    event.preventDefault();
    setPropertyData("");
    setError("");
    formik.resetForm();
    setTabValue(newValue);
    if (newValue === 2) {
      try {
        setLoading(true);
        const [zones, gats] = await Promise.all([
          getUserZoneList(),
          getGatByZonekey(),
        ]);
        const newZones = zones.map((zone) => {
          return {
            value: zone.zonename,
            label: zone.zonename,
          };
        });
        const newGats = gats.map((gat) => {
          return {
            value: gat.gatname,
            label: gat.gatname,
          };
        });
        setZonesList(newZones);
        setGatList(newGats);
      } catch (error) {
        showToastError(getErrorMsg(error));
      } finally {
        setLoading(false);
      }
    }
  };

  const handleSubmitButtonClick = async (e) => {
    e.preventDefault();
    let body = {};
    try {
      setError("");
      setLoading(true);
      switch (tabValue) {
        case 0:
          body = {
            searchPropertyBy: formik.values.searchPropertyBy,
          };
          const getPropertyByMobileOrPropertyNoRes =
            await getPropertyByMobileOrPropertyNo(body);
          showToastSuccess();
          setPropertyData(getPropertyByMobileOrPropertyNoRes);
          break;
        case 1:
          body = {
            upicid: formik.values.upicid,
          };
          const getPropertyByUPICIDRes = await getPropertyByUPICID(body);
          showToastSuccess();
          setPropertyData(getPropertyByUPICIDRes);
          break;
        case 2:
          body = {
            zoneName: formik.values.zone,
            gatNo: formik.values.gateNumber,
            propertyName: formik.values.propertyName,
            propertyAddress: formik.values.propertyAddress,
          };
          const getPropertyByMarathiNameRes = await getPropertyByMarathiName(
            body
          );
          showToastSuccess();
          setPropertyData(getPropertyByMarathiNameRes);
          break;
        default:
          break;
      }
    } catch (error) {
      showToastError(getErrorMsg(error));
    } finally {
      setLoading(false);
    }
  };

  return (
    <DashBoardContainer>
      <FormikProvider value={formik}>
        <Form>
          {success && <Alert severity="success">{success}</Alert>}
          {loading && <Loader />}
          {error && (
            <AlertMsg
              message={error}
              severity="error"
              onClose={() => {
                setError("");
              }}
            />
          )}

          <Paper elevation={4} sx={{ marginBottom: "15px" }}>
            <Tabs
              value={tabValue}
              onChange={handleChange}
              aria-label="Search Property"
              variant="scrollable"
              scrollButtons="auto"
              sx={{
                "& .MuiTab-root": {
                  minWidth: { xs: "120px", sm: "auto" }, // Min width for small screens
                  fontSize: { xs: "12px", sm: "inherit" }, // Font size adjusts based on screen size
                  padding: { xs: "6px", sm: "12px" }, // Adjust padding for mobile
                },
              }}
            >
              <Tab
                label="Search by Property / Mobile Number"
                sx={{ fontWeight: "600" }}
              />
              <Tab label="Search by UPICID" sx={{ fontWeight: "600" }} />
              <Tab label="Search In Marathi" sx={{ fontWeight: "600" }} />
            </Tabs>
            <Divider />
            <Grid>
              <TabPanel value={tabValue} index={0}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <FormLabel label="Property / Mobile No." />
                  <FormValue
                    component={<TextInput name="searchPropertyBy" required />}
                  />
                </Box>
              </TabPanel>
              <TabPanel value={tabValue} index={1}>
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                  }}
                >
                  <FormLabel label="UPICID Number" required />
                  <FormValue component={<TextInput name="upicid" required />} />
                </Box>
              </TabPanel>
              <TabPanel value={tabValue} index={2}>
                <GridRow>
                  <FormLabel label={labels.Zone[lang]} />
                  <FormValue
                    component={
                      <SelectInput name="zone" options={zonesList} required />
                    }
                  />
                  <FormLabel label={labels.GatNumber[lang]} />
                  <FormValue
                    component={
                      <SelectInput name="gateNumber" options={gatList} />
                    }
                  />
                </GridRow>
                <GridRow>
                  <FormLabel label={labels.PropertyName[lang]} />
                  <FormValue component={<TextInput name="propertyName" />} />
                  <FormLabel label={labels.propertyAddress[lang]} />
                  <FormValue component={<TextInput name="propertyAddress" />} />
                </GridRow>
              </TabPanel>
              <Grid container justifyContent="center" alignItems="center">
                <Grid
                  item
                  md={3}
                  container
                  justifyContent={{ md: "flex-end" }}
                  alignItems="center"
                  p={2}
                >
                  <Button
                    onClick={handleSubmitButtonClick}
                    variant="contained"
                    endIcon={<Search />}
                  >
                    Search
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          </Paper>
          {propertyData && propertyData.length ? (
            <TableContainer style={{ padding: "20px" }}>
              <Table
                size="small"
                sx={{ minWidth: 600 }}
                aria-label="simple table"
              >
                <TableHead>
                  <TableRow
                    sx={{
                      background: "#e6eaeb",
                      "&:last-child td, &:last-child th": {
                        border: "1px solid black",
                      },
                    }}
                  >
                    <TableCell align="center">{labels.SrNo[lang]}</TableCell>
                    <TableCell align="center">
                      {labels.PropertyCode[lang]}
                    </TableCell>
                    <TableCell align="center">
                      {labels.PropertyName[lang]}
                    </TableCell>
                    <TableCell align="center">
                      {labels.propertyAddress[lang]}
                    </TableCell>
                    <TableCell align="center">
                      {labels.MobileNo[lang]}
                    </TableCell>
                    {/* <TableCell align="center">{labels.emailId[lang]}</TableCell> */}
                  </TableRow>
                </TableHead>
                <TableBody>
                  {propertyData.map((item, index) => {
                    return (
                      <TableRow>
                        <TableCell align="center" className="cellBorder">
                          {index + 1}
                        </TableCell>
                        <TableCell align="center" className="cellBorder">
                          {item.propertyCode || "-"}
                        </TableCell>
                        <TableCell align="center" className="cellBorder">
                          {item.propertyName || "-"}
                        </TableCell>
                        <TableCell align="center" className="cellBorder">
                          {item.propertyAddress || "-"}
                        </TableCell>
                        <TableCell align="center" className="cellBorder">
                          {item.mobileNo || "-"}
                        </TableCell>
                        {/* <TableCell align="center" className="cellBorder">
                          {item.emailId || "-"}
                        </TableCell> */}
                      </TableRow>
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          ) : (
            propertyData && <Alert severity="info">Search Data Not Found</Alert>
          )}
        </Form>
      </FormikProvider>
      <ScrollTop />
    </DashBoardContainer>
  );
};
export default SearchProperty;
